import * as React from 'react'
// import TextareaAutosize from '@mui/base/TextareaAutosize'
// import TextareaAutosize from 'react-textarea-autosize'

import MyDiv from './customTextArea.style'

export default function CustomTextArea(props) {
  return (
    <MyDiv>
      {/* <TextareaAutosize
        value={props.value}
        onChange={props.onChange}
        minRows={props.minRows}
        name={props.name}
        placeholder={props.fieldLabel}
        className="custom_textarea"
      /> */}

      {/* <TextareaAutosize
        aria-label="minimum height"
        minRows={props.minRows}
        placeholder={props.fieldLabel}
        className="custom_textarea"
      /> */}
      <textarea
        value={props.value}
        onChange={props.onChange}
        rows={props.minRows}
        // cols={5}
        name={props.name}
        placeholder={props.fieldLabel}
        className="custom_textarea"
      />
    </MyDiv>
  )
}
